export const staffCompareFunction = (a, b, sortField) => {
  const firstItem = a[`${sortField}`]
  const secondItem = b[`${sortField}`]
  if (firstItem > secondItem) return 1
  if (firstItem < secondItem) return -1
  return 0
}
